<template>
    <div class="modal fade modal-upload" id="deleteUser" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog">
            <div class="modal-content">

                <div v-show="(loading == true)" class="loading-backdrop">
                    <div class="loading"></div>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>

                    <div class="center-modal">

                        <div class="center-ttl font300 d-flex justify-content-center">
                            <i class="icon-trash-g mr-2 mt-1"></i>
                            <span class="font500 text-pink">
                                {{ $t('user.delete.title') }}
                            </span>
                        </div>

                        <div class="error-message" v-if="alert_error" data-vv-scope='s1'>
                            <div class="d-flex">
                                <i class="icon-warning mr-2"></i>
                                <div class="errror-txt">
                                    <p class="fs-14 text-red font600">{{ $t('error.title') }}</p>
                                    <p class="fs-14 text-red font600">{{ alert_error }}</p>
                                </div>
                            </div>
                        </div>

                        <div v-if="(this.deleteObj.ids.length > 0 && alert_error == '')" data-vv-scope='s2'>
                            <div class="d-flex justify-content-center">
                                <div class="pr-2 w-165">
                                    <button class="btn btn-pink-53 w-100" :disabled="disabled" @click="deleteUser" ref="buttonDeleteUser" type="button">
                                        {{ $t('button.ok') }}
                                    </button>
                                </div>

                                <div class="pl-2 w-165">
                                    <button class="btn btn-gray-53 w-100" :disabled="disabled" data-dismiss="modal" type="button">
                                        {{ $t('button.cancel') }}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div v-else>
                            <div class="txc" v-if="this.deleteObj.ids.length <= 0" data-vv-scope='s3'>
                                {{ $t('user.general.no_select') }}
                            </div>

                            <div class="d-flex justify-content-center mt-4 pt-4">
                                <div class="pl-2 w-165">
                                    <button class="btn btn-pink-53 w-100" data-dismiss="modal" type="button">
                                        {{ $t('button.ok') }}
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
/* global $ */
import UserManagementService from '@/services/admin/user.service';
import StorageService from '@/services/common/storage.service';
import { AuthService } from '@/services/common/auth.service';
import Utils from '@/helpers/utils';
import store from '@/store/index';

export default {
    name: 'DeleteUserManagement',
    props: {
        deleteObj: [Object],
    },
    data () {
        return {
            alert_success: "",
            alert_error: "",

            loading: false,
            disabled: false,
        };
    },
    beforeCreate () {
        this.$forceUpdate();
    },
    created () {
        this.resetModal();
    },
    beforeMount () {
    },
    mounted () {
        let _this = this;
        $("#deleteUser").on('show.bs.modal', function () {
            store.commit('loading', false);
        });
        $("#deleteUser").on('hide.bs.modal', function () {
            _this.resetModal();
            // _this.$emit('unSlectAllUser');
            store.commit('loading', false);
        });
    },
    computed: {
    },
    watch: {
    },
    methods: {
        deleteUser: function deleteUser (event) {
            if (this.deleteObj.ids.length < 0) {
                return false;
            }

            this.loading = true;
            this.disabled = true;

            UserManagementService.deleteUser(this.deleteObj.ids)
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    }
                    if (response.status == 200) {
                        this.alert_success = this.$t('success.delete_success');
                        this.alert_error = "";
                        this.$toasted.success(this.alert_success, {icon: 'fa-check'});

                        this.$emit('unSlectAllUser');

                        $('#deleteUser').modal('hide');
                        $('.modal-backdrop').remove();
                    } else {
                        this.alert_success = "";
                        this.alert_error = this.$t('fail.delete_fail');

                        let errorCode = Utils.getErrorCode(response);
                        if (errorCode) {
                            this.alert_error = this.$t('error.error_code_' + errorCode);
                        }

                        // this.$toasted.error(this.alert_error, {icon: 'fa-exclamation-triangle'});
                    }

                    if (response.status == 403) {
                        this.alert_success = "";
                        this.alert_error = this.$t('error.error_' + response.status);
                    }

                    this.loading = false;
                    this.disabled = false;

                    this.$emit('updateListUser');

                    // this.$router.replace({path: '/admin/users', params: {alert_success: alert_success, alert_error: alert_error, force: true }});
                }).catch(error => {
                    this.alert_success = "";
                    this.alert_error = this.$t('fail.delete_fail');

                    // $('#deleteUser').modal('hide');
                    // $('.modal-backdrop').remove();
                    // this.$toasted.error(this.alert_error, {Icon: 'fa-exclamation-triangle'});

                    this.loading = false;
                    this.disabled = false;

                    // this.$router.replace({path: '/admin/users', params: {alert_success: alert_success, alert_error: alert_error, force: true}});
                });

            return false;
        },

        resetModal: function resetModal () {
            this.alert_success = "";
            this.alert_error = "";

            this.loading = false;
            this.disabled = false;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/admin/UserManagement/Delete.vue